exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchTable {\n  border-collapse: collapse;\n  width: 100%;\n}\n.searchTable thead {\n  background-color: #e5e7eb;\n}\n.searchTable thead th {\n  border-bottom: 1px solid #e5e7eb;\n  padding: 8px;\n}\n.searchTable tbody tr:hover {\n  background-color: rgba(229, 231, 235, .2784313725);\n}\n.searchTable tbody td {\n  border-bottom: 1px solid #e5e7eb;\n  padding: 8px;\n  cursor: pointer;\n}\n#searchBox {\n  left: 5% !important;\n  width: 90%;\n  max-height: 71vh;\n}\n\n/* Mobile devices (portrait) */\n@media only screen and (max-width: 767px) {\n#searchBox {\n    left: 0% !important;\n    width: 100%;\n}\n}\n", ""]);

// exports
